const Style = {

  tabs: 'overflow-hidden border-b border-solid border-slate-100 md:border-0',
  button: `relative float-left w-full px-10 py-3 outline-none text-sm
    ease-in-out duration-300 border-b border-solid border-slate-100 last:border-0
    md:w-auto md:border-0 md:bg-blue-400`,
    
  buttonActive: 'text-white bg-blue-400 md:text-slate-500 md:bg-white',
  buttonInActive: 'text-slate-500 bg-white md:text-white md:bg-blue-400',

}

export default Style;